import { TourGateState } from '../../types';

/**
 * The entitlement that unlocks the TZ+ tour.
 *
 * Distinct from the TOUR id (`tzplus`, see ./ids.ts): the tour id is a persisted key in redux and
 * in `user.tours` on the server and can never change, while this names what the user holds.
 */
export const TZ_PLUS_ENTITLEMENT = 'tour.tzPlus';

/**
 * The gate predicate, pure over `TourGateState` because `isEligible` is not a component and cannot
 * call a hook. `useHasTzPlusFeature` is the React twin; both ask the same entitlement, so the tour
 * and its mobile welcome cannot disagree about who is eligible — which they did while this read
 * `featuresUntil` and the welcome read the entitlement, and an admin saw the welcome on a phone for
 * a tour that never ran on a desktop.
 */
export const hasTzPlusFeature = (gate: TourGateState): boolean => gate.can(TZ_PLUS_ENTITLEMENT);
